<template>
<div class="container">
  <h1>Onze projecten </h1>
  <div class="highlights">
    <!-- <h2>highlights</h2> -->
    <div class="flex-container">
      <div class="project" @click="open">
        <img src="@/assets/img/metaalConservering.jpg"/>
        <p>Staal conservering</p>
      </div>
      <div class="project" @click="open">
        <img src="@/assets/img/betonConservering.jpg"/>
        <p>Beton conservering</p>
      </div>
      <div class="project" @click="open">
        <img src="@/assets/img/schilderwerken.jpg"/>
        <p>Schilderwerken</p>
      </div>
      <div class="project" @click="open">
        <img src="@/assets/img/multi.png"/>
        <p>Multidisciplinair</p>
      </div>
    </div>
  </div>
  <div class="content">
    <div class="searchbar">
      <input type="text" class="input-field" placeholder="type here to search a project"/>
      <div class="radio-group">
        <input type="radio" name="projecttype" value="metaal">Metaal
        <input type="radio" name="projecttype" value="beton"/>Beton
        <input type="radio" name="projecttype" value="multi disciplinair"/>Multi disciplinair
      </div>
    </div>
  </div>
</div>
</template>
<script>
import Event from '@/event.js';
export default {
  name: 'Galery',
  methods: {
    open () {
      console.log('open');
      Event.$emit('open');
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  width: 90%;
  margin-left: 5%;
  padding-top: 15px;
  padding-bottom: 15px;
}
  .highlights {
    text-align: left;
  }
  .flex-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-align: center;
    .project {
      position: relative;
      padding: 10px;
      img {
        width: 300px;
        height: 200px;
        background: none;
      }
      p {
        width: 300px;
        position: absolute;
        top: 173px;
        padding-top: 10px;
        padding-bottom: 10px;
        background: rgba(0, 0, 0, 0.75);
        color: white;
      }
    }
    .project:hover {
      cursor: pointer;
      img {
        opacity: 0.5;
      }
    }
  }

  .input-field {
    font-size: 18px;
    padding: 18px;
    width: 100%;
    border-color: darkgray;
  }
  .radio-group {
    font-size: 30px;
    padding: 10px;
  }
</style>

